import React from 'react';
import PropTypes from 'prop-types';
import InserisciQuesito from '../../Shared/InserisciQuesito/InserisciQuesito';

/**
*/
const CompilaQuestionario = ({
  codiceArea, fileUploadHelper, ufficioSelezionato,
  oggetto, messaggio, onChangeOggetto, onChangeMessaggio, allegati, onChangeAllegati, onUploadingAllegatoChange,
}) => (
  <InserisciQuesito
    ufficioSelezionato={ufficioSelezionato}
    codiceArea={codiceArea}
    fileUploadHelper={fileUploadHelper}
    onChangeOggetto={onChangeOggetto}
    oggetto={oggetto}
    onChangeMessaggio={onChangeMessaggio}
    messaggio={messaggio}
    onChangeAllegati={onChangeAllegati}
    allegati={allegati}
    onUploadingAllegatoChange={onUploadingAllegatoChange}
    nessunSuggerimentoComponent={(
      <div
        className="helpdesk-frontend-step__image  helpdesk-frontend-questionario__soluzioni__image"
      >
        <img
          src="/images/Illustrazione-Ominoalcomputer.svg"
          alt="immagine-questionario"
        />
      </div>
    )}
  />
);

CompilaQuestionario.propTypes = {
  codiceArea: PropTypes.string,
  fileUploadHelper: PropTypes.string,
  ufficioSelezionato: PropTypes.string,

  onChangeOggetto: PropTypes.func.isRequired,
  oggetto: PropTypes.string,

  onChangeMessaggio: PropTypes.func.isRequired,
  messaggio: PropTypes.string,

  onChangeAllegati: PropTypes.func.isRequired,
  allegati: PropTypes.arrayOf(PropTypes.shape({

  })),

  onUploadingAllegatoChange: PropTypes.func.isRequired,
};

CompilaQuestionario.defaultProps = {
  ufficioSelezionato: undefined,
  codiceArea: undefined,
  fileUploadHelper: undefined,
  oggetto: '',
  messaggio: '',
  allegati: [],
};

export default CompilaQuestionario;
